import $ from "jquery";
import "jquery-validation";
import "../bootstrap.js";

document.addEventListener("DOMContentLoaded", async () => {
  const contactForm = $("#form-contact")[0];
  if (!contactForm) return;

  const { renderContact } = await import("../components/contact.js");
  renderContact(contactForm);

  const { renderValidateContact } = await import("../components/validate-contact.js");
  renderValidateContact(contactForm);

  const { renderValidateAbroadConsultform } = await import("../components/validate-abroad-consultform.js");
  renderValidateAbroadConsultform(contactForm);

  $("#search_zip").on("click", () => {
    const prefecture = $("#prefecture").val();
    const address = $("#address").val();
    if (!prefecture && !address) return;

    loadZipSearchResults(1, prefecture, address);
  });

  $("#search_address").on("click", (event) => {
    event.preventDefault();
    clearErrorNotify();
    const zip1 = $("#input_zip_1").val();
    const zip2 = $("#input_zip_2").val();
    const zip = [zip1, zip2].join("");

    // Validate zip1 và zip2
    const errors = validateZipCode(zip1, zip2);
    if (errors.length > 0) {
        errors.forEach(error => showError(error.field, error.message));
        return;
    }

    $("#input_pref_cd, #input_address, #input_address_detail").val('')

    $.getJSON(load_zip_url, { zip }).done((res) => {
      const datas = res?.data;
      const data = res?.data?.[0];
      if (data) {
        if(undefined !== datas[0] && undefined !== datas[1] && datas[0].pref_cd == datas[1].pref_cd && datas[0].address2 != datas[1].address2) {
            $("#input_pref_cd").val(pref_map[data.pref_cd]);
            $("#input_address").val(data.address1 || "");
            showError('input_address_detail', '複数の住所が該当します。お手数ですが、正しい住所を入力してください。')
        }else if(undefined !== datas[0] && undefined !== datas[1] && datas[0].pref_cd != datas[1].pref_cd && datas[0].address1 != datas[1].address1) {
            showError('input_pref_cd', '複数の住所が該当します。お手数ですが、正しい住所を入力してください。')
        }else if(datas.length > 2) {
            showError('input_pref_cd', '複数の住所が該当します。お手数ですが、正しい住所を入力してください。')
        } else {
            $("#input_pref_cd").val(pref_map[data.pref_cd]);
            $("#input_address").val(data.address1 || "");
            $("#input_address_detail").val(data.address2 || "");
        }
      }
    });
  });

  $("body").on("click", ".form-postcode__btn", function () {
    const zip = String($(this).data("zip"));
    const item = $(this).closest(".form-postcode__item");
    const addressText = item.find(".ttl").text().trim();

    $("#input_zip_1").val(zip.slice(0, 3));
    $("#input_zip_2").val(zip.slice(3));

    const parts = addressText.split(/\s|\u00A0/).filter(Boolean);

    $("#input_pref_cd").val(parts[0] || "");
    $("#input_address").val(parts[1] || "");
    $("#input_address_detail").val(parts.slice(2).join(" ") || "");

    clearErrorNotify();
  });

});

function loadZipSearchResults(page = 1, prefecture = "", address = "") {
  $.getJSON(search_zip_url, { prefecture, address, page }).done((res) => {
    const data = res?.data || [];
    const meta = res?.meta || {};
    const $resultBox = $("#postcodeResultBox");

    if (!data.length) {
      return $resultBox.fadeOut("fast", function () {
        $(this).empty();
      });
    }

    const totalPages = meta.last_page || 1;
    const currentPage = meta.current_page || 1;

    const listHtml = data.map(renderZipItem).join("");
    const paginationHtml = renderPagination(currentPage, totalPages);

    $resultBox
      .html(
        `<div class="form-postcode__list pagination-content resultContent">
          ${listHtml}
        </div>${paginationHtml}`
      )
      .slideDown("fast");

    bindZipResultEvents($resultBox, currentPage, totalPages, prefecture, address);
  });
}

function renderZipItem(v) {
  const zipFormatted = `${v.zip.slice(0, 3)}-${v.zip.slice(3)}`;
  const addressText = `${v.pref_cd} ${v.address1 || ""} ${v.address2 || ""}`.trim();

  return `
    <div class="form-postcode__item">
      <p class="form-postcode__wrap">
        <span class="zip">${zipFormatted}</span>
        <span class="ttl">${addressText}</span>
      </p>
      <button type="button" class="form-postcode__btn postcode__item" data-zip="${v.zip}">
        選択
      </button>
    </div>`;
}

function bindZipResultEvents($container, currentPage, totalPages, prefecture, address) {
  $container.find(".postcode__item").on("click", function () {
    const zip = String($(this).data("zip"));
    $("#input_zip_1").val(zip.slice(0, 3));
    $("#input_zip_2").val(zip.slice(3));

    clearErrorNotify();
    $("#search_address").trigger("click");

    $("html, body").animate({
      scrollTop: $("#postcodeResultBox").offset().top - 150,
    });
  });

  $container.find(".pagination a[data-page]").on("click", function (e) {
    e.preventDefault();
    const newPage = $(this).data("page");
    if (newPage && newPage !== currentPage) {
      loadZipSearchResults(newPage, prefecture, address);
    }
  });
}

function renderPagination(current, total) {
  if (total <= 1) return "";

  const createPage = (page, label = page, isActive = false) =>
    `<a href="#" class="c-pagination__item ${
      isActive ? "c-pagination__item--active" : ""
    }" data-page="${page}">${label}</a>`;

  let html = '<div class="pagination c-pagination form-postcode__paging pagination-json">';

  if (current > 1) html += createPage(current - 1, "&laquo;");

  const range = 2;
  for (let i = Math.max(1, current - range); i <= Math.min(total, current + range); i++) {
    html += createPage(i, i, i === current);
  }

  if (current < total) html += createPage(current + 1, "&raquo;");
  html += "</div>";

  return html;
}

function clearErrorNotify() {
  $("#input_zip_1, #input_zip_2, #input_pref_cd, #input_address, #input_address_detail, #input_zip_1, #input_zip_2")
    .removeClass("errorNotify notify-error");
  $('#data_input_zip_1').remove();
  $('#data_input_zip_2').remove();
  $('#data_pref_cd').remove();
  $('#data_address_detail').remove();
}

function validateZipCode(zip1, zip2) {
  const errors = [];
  const wrongFormatMsg = '正しい形式で郵便番号を入力してください';

  if (!zip1) {
    errors.push({ field: 'input_zip_1', message: '郵便番号（前）を入力してください' });
  }
  else if (!/^[0-9]+$/.test(zip1)) {
    errors.push({ field: 'input_zip_1', message: wrongFormatMsg });
  }
  else if (zip1.length !== 3) {
    errors.push({ field: 'input_zip_1', message: '正しい形式で郵便番号を入力してください' });
  }

  if (!zip2) {
    errors.push({ field: 'input_zip_2', message: '郵便番号（後）を入力してください' });
  }
  else if (!/^[0-9]+$/.test(zip2)) {
    errors.push({ field: 'input_zip_2', message: wrongFormatMsg });
  }
  else if (zip2.length !== 4) {
    errors.push({ field: 'input_zip_2', message: '正しい形式で郵便番号を入力してください' });
  }

  return errors;
}

function showError(fieldId, message) {
  const $field = $(`#${fieldId}`);
  $field.addClass("notify-error");
  $field.parent().append(
    `<span class="notify-vad" data-input="${fieldId}" id="data_${fieldId}">${message}</span>`
  );
}
